import { render, staticRenderFns } from "./ProposedScheduleTable.vue?vue&type=template&id=267b2427"
import script from "./ProposedScheduleTable.vue?vue&type=script&lang=ts"
export * from "./ProposedScheduleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports